export default __webpack_public_path__ + "static/media/Black Bear.9c56e3ff.jpg";